/**
 * Import React libraries.
 */
import * as React from 'react';

/**
 * Import custom styles.
 */
import { COLORS } from '../styles';

/**
 * Import third-party libraries.
 */
import styled from 'styled-components';

// Add component-specific styles.
const Label = styled.label`
  font-size: 18px;
  color: ${COLORS.neutral_600};
  font-style: normal;
  font-weight: normal;
`;

// Add component-specific types
type LabelProps = {
  inputId: string;
  text: string;
};

const InputLabel: React.FunctionComponent<LabelProps> = ({ inputId, text }: LabelProps) => {
  /**
   * Triggers a click element on a specific element.
   * @param id - ID of the element which needs to be clicked.
   */
  const onTriggerClick = (id: string): void => {
    document.getElementById(id)?.click();
  }

  return (
    <Label htmlFor={inputId} onClick={() => onTriggerClick(inputId)}>
      { text }
    </Label>
  );
};

export default InputLabel;
